/**
 * User Prompt when there is no data to be displayed
 *
 * created by Ty D'Angelo 11/21/2022
 */

import React from 'react'
import { CenteredAlignedContainer } from '../BaseComponents'

interface promptProps {
  message: string
}

export default function Prompt(p: promptProps) {
  return (
    <CenteredAlignedContainer>
      {p.message}
    </CenteredAlignedContainer>
  )
}
